(() => {
  if (window.GTGameSections) { window.GTGameSections.scan(); return; }
  const instances = new Map();
  const libraries = new Map();
  function library(url) {
    if(!libraries.has(url)) libraries.set(url,new Promise((resolve,reject)=>{
      const s=document.createElement('script');s.src=url;s.onload=resolve;s.onerror=reject;document.head.append(s);
    }));
    return libraries.get(url);
  }
  function init(el) {
    if(instances.has(el)) return;
    const mount=el.querySelector('.gt-game__mount');
    let game;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let world, visible=false, disposed=false, ro, sceneStarted=false, prevActive=false, spinTimer=null;
    const controls=el.querySelector('.gt-game__controls');
    const click=e=>{const b=e.target.closest('[data-trash]');if(b)game?.clearTrash(b.dataset.trash);};
    controls?.addEventListener('click',click);
    const quiz=el.querySelector('.gt-game__quiz');
    const question=quiz.innerHTML;
    function quizClick(e){
      if(e.target.closest('[data-quiz-reset]')){
        quiz.innerHTML=question;quiz.classList.remove('gt-game__quiz--result');
        quiz.querySelector('button').focus();return;
      }
      const answer=e.target.closest('[data-quiz-answer]');if(!answer)return;
      const correct=answer.dataset.quizAnswer==='2';
      quiz.classList.add('gt-game__quiz--result');
      const L=document.documentElement.lang.indexOf('en')===0
        ?{ok:'Correct!',thanks:'Thanks for guessing!',answer:'One child in five.',reveal:'The correct answer:<br>One child in five.',help:'Help change something.',order:'Order now',again:'Guess again'}
        :{ok:'Richtig!',thanks:'Danke fürs Mitraten!',answer:'Jedes fünfte Kind.',reveal:'Die richtige Antwort:<br>Jedes fünfte Kind.',help:'Hilf mit etwas zu verändern.',order:'Jetzt bestellen',again:'Nochmal raten'};
      quiz.innerHTML='<div class="gt-quiz-result"><div class="gt-quiz-result__icon" aria-hidden="true">'+(correct?'✦ ✓ ✦':'✦')+'</div><h3 tabindex="-1">'+(correct?L.ok:L.thanks)+'</h3><p class="gt-quiz-result__answer">'+(correct?L.answer:L.reveal)+'</p><p>'+L.help+'</p><button type="button" data-quiz-reset>'+L.again+'</button></div>';
      const target=el.querySelector('.gt-game__cta');
      if(target){const link=document.createElement('a');link.href=target.href;link.className='gt-quiz-result__cta';link.textContent=L.order;quiz.querySelector('[data-quiz-reset]').before(link);}
      quiz.querySelector('h3').focus({preventScroll:true});
    }
    quiz.addEventListener('click',quizClick);
    function motion(){
      const active=visible&&!document.hidden;
      if(active&&!prevActive&&world&&!reduced.matches){
        clearInterval(spinTimer);
        const c=world.controls();
        let speed=-2.6;
        c.autoRotateSpeed=speed;
        spinTimer=setInterval(()=>{
          if(!world||disposed||reduced.matches){clearInterval(spinTimer);return}
          speed+=0.18;
          if(speed>=-0.33){speed=-0.33;clearInterval(spinTimer);}
          c.autoRotateSpeed=speed;
        },90);
      }
      prevActive=active;
      if(game) active?game.resume():game.pause();
      if(world){world.controls().autoRotate=!reduced.matches;active?world.resumeAnimation():world.pauseAnimation();}
    }
    async function startGame(){
      try {
        if(!window.GTCreateTurtle) await library(el.dataset.turtleLib);
        if(disposed)return;
        game=window.GTCreateTurtle(mount);motion();
      } catch(error) {
        if(disposed)return;
        const fallback=document.createElement('p');
        fallback.className='gt-game__load-error';
        fallback.textContent=document.documentElement.lang.indexOf('en')===0?'The game could not be loaded. Please reload the page.':'Das Spiel konnte nicht geladen werden. Bitte lade die Seite erneut.';
        mount.replaceChildren(fallback);console.warn('24GT game:',error);
      }
    }
    function startScene(){if(sceneStarted||disposed)return;sceneStarted=true;startGame();globe();}
    const io='IntersectionObserver' in window ? new IntersectionObserver(entries=>{
      visible=entries[0].isIntersecting;if(visible)startScene();motion();
    },{rootMargin:'250px'}) : null;
    if(io)io.observe(el.querySelector('.gt-game__visual'));
    else{visible=true;startScene();}
    document.addEventListener('visibilitychange',motion);
    reduced.addEventListener('change',motion);
    async function globe(){
      try{
        if(!window.Globe)await library(el.dataset.globeLib);
        if(disposed)return;
        const response=await fetch(el.dataset.countries);
        if(!response.ok)throw Error('Länder-Daten konnten nicht geladen werden');
        const geo=await response.json();if(disposed)return;
        const target=el.querySelector('.gt-game__globe');
        world=Globe()(target).backgroundColor('rgba(0,0,0,0)')
          .globeImageUrl(el.dataset.ocean).showAtmosphere(false)
          .polygonsData(geo.features)
          .polygonCapColor(d=>{const P={DE:1,DEU:1,COL:1,TG:1,MDG:1,YE:1,UG:1,ET:1,ETH:1,IN:1,GR:1,GRC:1,NP:1,BD:1,BGD:1,MW:1,UA:1,UKR:1,AF:1,AFG:1,NA:1,NAM:1,FR:1,FRA:1,TH:1,THA:1};const c=(d.properties.iso_a2||'')+'';const a=d.properties.iso_a3||'';return (P[c]||P[a])?'#FCBD00':'#EBEBEB'})
          .polygonSideColor(()=> '#EBEBEB').polygonStrokeColor(()=> '#EBEBEB')
          .polygonAltitude(.005).polygonsTransitionDuration(0);
        world.pointOfView({lat:35,lng:12,altitude:1.7},0);
        world.controls().enableZoom=false;world.controls().enablePan=false;world.controls().enableRotate=false;
        world.controls().autoRotate=true;world.controls().autoRotateSpeed=-.33;
        world.scene().children.forEach(c=>{if(c.type==='AmbientLight')c.intensity=3;if(c.type==='DirectionalLight')c.intensity=0;});
        ro=new ResizeObserver(()=>{const w=target.clientWidth;world.width(w).height(w);});
        ro.observe(target);target.dataset.ready='true';motion();
      }catch(error){el.querySelector('.gt-game__globe').dataset.error='true';console.warn('24GT globe:',error);}
    }
    instances.set(el,{get game(){return game;},getWorld:()=>world,destroy(){
      disposed=true;clearInterval(spinTimer);quiz.removeEventListener('click',quizClick);io?.disconnect();ro?.disconnect();game?.destroy();world?._destructor();
      controls?.removeEventListener('click',click);document.removeEventListener('visibilitychange',motion);reduced.removeEventListener('change',motion);instances.delete(el);
    }});
  }
  function scan(){document.querySelectorAll('[data-gt-game]').forEach(init);}
  window.GTGameSections={scan,instances};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',e=>instances.forEach((v,el)=>{if(e.target.contains(el))v.destroy();}));
})();
